<template lang="pug">
.card
    .card-content
        .media
            .media-left
                figure.image.is-48x48
                    img(src="@/assets/symbols/calendar.png")
            .media-content
                p.title.is-5.has-text-weight-medium Next Event
                p.subtitle.is-6.has-text-weight-light Contract Discussion Meeting
                p.subtitle.is-6.has-text-weight-light 8/30/20 @ 7 pm
</template>

<script>
export default {
  name: "NextEvent"
};
</script>
